<template>
  <div class="login">
    <div class="loginContainer">
      <img :src="`${BASE_URL}images/logo.png`" class="logo-img">
      <div class="login-wrapper">
        <div class="login-card">
          <div class="login-form-container">
            <div class="el-tabs-nav"><img :src="`${BASE_URL}images/login_logo.png`" class="login-top-img"></div>
            <el-form class="login-form" ref="form" :model="params" :rules="rules" label-position="top" @validate="formValidate">
              <div class="label">输入手机号</div>
              <el-form-item prop="phoneNumber" class="form-item">
                <el-input
                  type="text"
                  class="form-input numrule"
                  maxlength="11"
                  autocomplete="on"
                  v-model="params.phoneNumber"
                  @focus="handlePhone"
                  @keyup.native="checkPhoneNumber"
                  placeholder="手机号"></el-input>
              </el-form-item>
              <div class="label">输入验证码</div>
              <el-form-item prop="vertifyCode" class="form-item">
                <el-input
                  type="text"
                  class="form-input numrule"
                  maxlength="6"
                  autocomplete="on"
                  v-model="params.vertifyCode"
                  placeholder="验证码"
                  @focus="handleCode"
                  @keyup.native="checkVerifyCode"
                ></el-input>
              </el-form-item>
              <div v-if="show" class="verify-code-box" @click="showSlideCheck">
                <span class="orangeBtn verify-btn">{{btnName}}</span>
              </div>
              <div v-if="!show" class="verify-code-box">
                <span class="greyBtn verify-btn">重新获取({{count}})</span>
              </div>
            </el-form>
            <el-button class="submit" :class="{ action: canSubmit }" :loading="btnLoading" @click="submit">登录</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="tips">
      Copyright © 2017-2021 北京聪明核桃教育科技有限公司<br />
      <a href="https://beian.miit.gov.cn/" target="_blank">京公网安备 11010802026814号 京ICP备17052426号-2 京网文 [2018] 4745-385号 | 京ICP备19032297号-1</a>
    </div>
    <!--验证码弹窗-->
    <div class="slidingPictures" v-if="visible">
      <div class="sliding-pictures">
        <div class="close" @click="closeSlideCheck">
          <span>关闭</span>
        </div>
        <slide-check
          :width="300"
          :height="220"
          :src="src"
          @success="success"
          @fail="fail">
        </slide-check>
        <div class="close" @click="closeSlideCheck">
          <span>关闭</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCode, login } from '@/services/user';
import Cookie from 'js-cookie';
import qs from 'qs'
import "vue-gn-components/lib/style/index.css";

const PHONE_REGEX = /^1[3-9]\d{9}$/

export default {
  name: 'Login',
  data () {
    // 验证手机
    const checkPhone = (rule, value, callback) => {
      const reg = PHONE_REGEX;
      if (!reg.test(value)) {
        callback(new Error('请输入11位手机号'))
      } else {
        callback()
      }
    }
    // 校验验证码
    const checkCode = (rule, value, callback) => {
      if (value && value.length !== 6) {
        callback(new Error('请输入 6 位纯数字验证码'))
      } else {
        callback()
      }
    }
    return {
      BASE_URL: process.env.BASE_URL,
      btnLoading: false,
      params: {
        phoneNumber: null,
        vertifyCode: undefined
      },
      rules: {
        phoneNumber: [
          { required: true, message: '请输入正确的手机号', trigger: 'blur' },
          { type: 'number', validator: checkPhone, message: '请输入正确的手机号', trigger: ['blur'] }
        ],
        vertifyCode: [
          { required: true, message: '请输入正确的短信验证码', trigger: 'blur' },
          { type: 'number', validator: checkCode, message: '请输入 6 位纯数字验证码', trigger: ['blur'] }
        ]
      },
      redirect: undefined,
      otherQuery: {},
      show: true,
      count: '',
      timer: null,
      btnName: '获取验证码',
      phoneColor: false,
      codeColor: false,
      visible: false, // 弹窗开启关闭
      src: [
        'https://img.hetao101.com/assets/slide-check/slideNew.png',
        'https://img.hetao101.com/assets/slide-check/slideOne.jpg',
        'https://img.hetao101.com/assets/slide-check/slideTwo.png',
        'https://img.hetao101.com/assets/slide-check/slideThr.png'
      ]
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    }
  },
  computed: {
    canSubmit() {
      return PHONE_REGEX.test(String(this.params.phoneNumber || '')) && /^\d{6}$/.test(String(this.params.vertifyCode || ''))
    }
  },
  methods: {
    formValidate(valid) {
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
    checkLength (e) {
      if (e.length > 11) {
        this.params.phoneNumber = e.slice(0, 11)
      }
    },
    checkPhoneNumber() {
      const regNum = /[^\d]/g;
      this.params.phoneNumber = this.params.phoneNumber && regNum.test(this.params.phoneNumber) ? this.params.phoneNumber.toString().replace(/[^\d]/g, '') : this.params.phoneNumber;
    },
    checkVerifyCode() {
      const regNum = /[^\d]/g;
      this.params.vertifyCode = this.params.vertifyCode && regNum.test(this.params.vertifyCode) ? this.params.vertifyCode.toString().replace(/[^\d]/g, '') : this.params.vertifyCode;
    },
    checkColde (e) {
      if (e.length > 6) {
        this.params.vertifyCode = e.slice(0, 6)
      }
    },
    handlePhone() {
      this.phoneColor = false
      if (this.$refs.form) {
        this.$refs.form.clearValidate('phoneNumber')
      }
    },
    handleCode() {
      this.codeColor = false
      if (this.$refs.form) {
        this.$refs.form.clearValidate('vertifyCode')
      }
    },
    // 倒计时
    countDown() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 1 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
            this.btnName = '重新获取'
          }
        }, 1000)
      }
    },
    // 拼图验证
    showSlideCheck() {
      const { phoneNumber } = this.params;
      const regex = PHONE_REGEX;
      if (!regex.test(phoneNumber)) {
        // 单独触发校验
        if (this.$refs.form) {
          this.$refs.form.validateField('phoneNumber')
        }
        this.phoneColor = true
        return;
      }
      this.phoneColor = false
      this.visible = true
    },
    closeSlideCheck() {
      this.visible = false;
    },
    // 拼图验证失败
    fail() {
      this.$notify.error({
        title: '提示',
        message: '拼图验证失败, 请重新验证'
      });
    },
    // 拼图验证成功
    success(pos) {
      // 获取验证码
      this.getVertifyCode();
      setTimeout(() => {
        this.visible = false
      }, 0)
    },
    // 获取验证码
    getVertifyCode() {
      const { phoneNumber } = this.params;
      getCode(phoneNumber)
        .then((res) => {
          if (res && res.data && res.data.errCode === 0) {
            this.$notify({
              title: '成功',
              message: '验证码发送成功，请查看手机短信',
              type: 'success'
            });
            // 倒计时
            this.countDown();
          }
        })
        .catch(() => {
          this.$notify.error({
            title: '消息',
            message: '验证码发送失败，请重新获取验证码'
          });
        });
    },
    submit () {
      if (!this.canSubmit) {
        return;
      }
      this.$refs.form.validate((valid) => {
        const { phoneNumber, vertifyCode } = this.params;
        const regex = PHONE_REGEX;
        if (valid) {
          this.phoneColor = false
          this.codeColor = false
          login({ phone: phoneNumber, code: vertifyCode }).then((res) => {
            if (res.data && res.data.errCode === 0) {
              const expiresTime = { expires: 9 }
              const { data } = res.data
              const { loginInfos } = data;
              if (loginInfos && loginInfos.length > 0) {
                localStorage.setItem("loginInfos", JSON.stringify(loginInfos) || []);
                Cookie.set('staffToken', data.token || '', expiresTime)
                Cookie.set('agentCode', loginInfos[0].agentCode || '', expiresTime)
                Cookie.set('agentName', loginInfos[0].name || '', expiresTime)
                Cookie.set('agentStatus', loginInfos[0].agentStatus || '', expiresTime)
                Cookie.set('teamCode', loginInfos[0].teamCode || '', expiresTime)
                Cookie.set('teamType', loginInfos[0].teamType || '', expiresTime)
                Cookie.set('teamRole', loginInfos[0].teamRole || '', expiresTime)
                Cookie.set('teamStatus', loginInfos[0].teamStatus || '', expiresTime)
                Cookie.set('teamName', loginInfos[0].abbreviation || loginInfos[0].fullName || '', expiresTime)
                Cookie.set('conversionPath', loginInfos[0].conversionPath || null, expiresTime)
                const pathQuery = `${this.redirect || '/'}${this.redirect && Object.keys(this.otherQuery).length > 0 ? '?' + qs.stringify(this.otherQuery) : ''}`
                window.location.href = window.location.origin + `${pathQuery}`
              }
            } else if (res.data && res.data.errCode === 1016) {
              this.$message({ type: 'error', message: 'token认证失败，当前用户没有登录，请重新登录' })
              Cookie.remove('staffToken')
              setTimeout(() => {
                this.$router.push({ path: '/login' })
              }, 3000)
            } else {
              this.$notify.error({
                title: '消息',
                message: res.data.errMsg || '你输入的手机号和验证码不一致，请重新输入'
              });
            }
          })
        } else if (!regex.test(phoneNumber)) {
          if (this.$refs.form) {
            this.$refs.form.validateField('phoneNumber')
          }
          this.phoneColor = true
        } else if (!vertifyCode || (vertifyCode && vertifyCode.length !== 6)) {
          if (this.$refs.form) {
            this.$refs.form.validateField('vertifyCode')
          }
          this.codeColor = true
        } else {
          this.phoneColor = true
          this.codeColor = true
        }
      })
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.numrule input::-webkit-outer-spin-button),
:deep(.numrule input::-webkit-inner-spin-button) {
  -webkit-appearance: none!important;
  margin: 0;
}
:deep(.numrule input[type="number"]) {
  // line-height: 1px!important;
  -moz-appearance: textfield;
  appearance:textfield !important;
  -webkit-appearance:textfield !important;
}
.login {
  overflow: auto;
  z-index: 20;
  min-width: 1366px;
  min-height: 1009px;
  background: url("@{BASE_URL}images/bg.png") no-repeat top center / auto 1009px;
  .box {
    min-height: 1009px;
    width: 1366px;
    height: 100%;
    margin: 0 auto;
    position: relative;
    z-index: 10;
  }
  .logo-img {
    width: 363px;
    display: block;
    position: absolute;
    top: 98px;
    left: 60px;
    z-index: 10;
  }
  .login-logo {
    & > h3 {
      font-size: 40px;
      text-align: center;
      margin-top: 3%;
      color:#666666;
      & > img {
        vertical-align: middle;
        margin-right: 10px;
        margin-top: -10px;
        height: 60px;
      }
    }
  }
  .loginContainer{
    padding-top: 228px;
    width: 1366px;
    margin: 0 auto;
    display: flex;
    position: relative;
    flex-direction: row-reverse;
    .login-wrapper{
      display: flex;
      height: 550px;
      .login-bg {
        position: relative;
        width: 520px;
        height: 100%;
        background:url('//img.pipacoding.com/assets/fe-agent-client/login.png') no-repeat center center / 100% 100%;
      }
      .login-card {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 520px;
        height: 100%;
        background-color: #fff;
        z-index: 100;
        border-radius: 4px;
        color: rgba(7,20,46,.3);
        .el-tabs-nav {
          margin-bottom: 20px;
          color:#666666;
          font-size: 20px;
          text-align: center;
          .login-top-img {
            width: 374px;
          }
        }
        .login-form {
          .label {
            padding: 6px 0;
            font-weight: bold;
            color: #09090B;
            font-size: 16px;
            line-height: 24px;
          }
          .form-item{
            width: 380px;
            border:none;
          }
          .form-input {
            width: 340px;
            height: 24px;
            padding: 20px;
            line-height: 24px;
            /deep/ .el-input__inner {
              padding-left: 0px;
              font-size: 16px;
              height: 24px;
              line-height: 24px;
              color: rgba(0,0,0,.88);
              &::-webkit-input-placeholder {
                color: #75829B !important;
              }
              &:-moz-placeholder {/* Firefox 18- */
                color: #75829B !important;
              }
              &::-moz-placeholder{/* Firefox 19+ */
                color: #75829B !important;
              }
              &:-ms-input-placeholder {
                color: #75829B !important;
              }
              background-color: transparent;
              border-color: transparent;
            }
            border: 1px solid #E4E4E7;
            border-radius: 5px;
            &:hover {
              border-color: #000;
            }
          }
          .verify-code-box{
            position: relative;
            top: -70px;
            z-index: 1;
            float: right;
            .verify-btn {
              background-color: transparent;
              color: #FF9900;
            }
            .orangeBtn, .greyBtn {
              width: 104px;
              height: 36px;
              border-radius: 22px;
              line-height: 34px;
              font-size: 16px;
              display: inline-block;
              text-align: center;
              background: #fff;
              cursor: pointer;
            }
            .orangeBtn{
              color: #FF9900;
            }
            .greyBtn{
              color: #CCCCCC;
            }
          }
        }
        .submit {
          margin: 0px 0 0px;
          width: 380px;
          height: 64px;
          border-radius: 4px;
          color: #fff;
          background-color: #FF5000;
          border: 0;
          font-weight: 600;
          font-size: 16px;
          opacity: .4;
          &.action {
            opacity: 1;
          }
        }
      }
    }
  }
  .tips{
    clear: both;
    width: 100%;
    min-width: 1200px;
    height:60px;
    padding-top: 160px;
    text-align: center;
    font-size:14px;
    font-weight:400;
    color:rgba(0,0,0,.65);
    line-height:20px;
    a{
      font-size: 12px;
      color:rgba(0,0,0,.45);
    }
  }
}
.slidingPictures {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(58, 34, 34, 0.1);
  z-index: 9999;
  .sliding-pictures {
    position: absolute;
    background-color: #fff;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    z-index: 99999;
  }
  .close{
    position: absolute;
    left: 64%;
    top: 8px;
    color: #06c;
    font-size: 14px;
    z-index: 99999;
    span{
      display: inline-flex;
      width: 30px;
      height: 20px;
      cursor: pointer;
      padding: 8px 10px;
    }
  }
}
</style>
